if (typeof ShippingNotice !== 'function') {

  class ShippingNotice extends HTMLElement {

    constructor() {
      super();
      this.init();
    }

    async init() {
      const cartTotal = Number(this.getAttribute('data-cart-total-amount')) / 100; // converting to euros
      let countryCode = this.getAttribute('data-country-code');

      // If no country code is available from the cart, use a geolocation API
      if (!countryCode) {
        countryCode = await this.getCountryCodeFromGeolocation();
        countryCode = countryCode.toUpperCase();
      }

        if (countryCode === 'DK') {
          this.style.display = 'none';
          this.innerHTML = '';
          return;
        }
      // Log the detected country code
      console.log('Detected Country Code:', countryCode);

      // Define default and country-specific thresholds
      const freeShippingThresholds = {
        DEFAULT: Number(this.getAttribute('data-free-shipping-default')) / 100 || 0,
        FI: Number(this.getAttribute('data-free-shipping-FI')) / 100 || 0,
        LT: Number(this.getAttribute('data-free-shipping-LT')) / 100 || 0,
        DE: Number(this.getAttribute('data-free-shipping-DE')) / 100 || 0,
        FR: Number(this.getAttribute('data-free-shipping-FR')) / 100 || 0,
        HU: Number(this.getAttribute('data-free-shipping-HU')) / 100 || 0,
        LV: Number(this.getAttribute('data-free-shipping-LV')) / 100 || 0,
        US: Number(this.getAttribute('data-free-shipping-US')) / 100 || 0,
        SE: Number(this.getAttribute('data-free-shipping-SE')) / 100 || 0,
        BE: Number(this.getAttribute('data-free-shipping-BE')) / 100 || 0,
        AT: Number(this.getAttribute('data-free-shipping-AT')) / 100 || 0,
        SI: Number(this.getAttribute('data-free-shipping-SI')) / 100 || 0,
        IT: Number(this.getAttribute('data-free-shipping-IT')) / 100 || 0,
        IE: Number(this.getAttribute('data-free-shipping-IE')) / 100 || 0,
        CH: Number(this.getAttribute('data-free-shipping-CH')) / 100 || 0,
        PT: Number(this.getAttribute('data-free-shipping-PT')) / 100 || 0,
        CZ: Number(this.getAttribute('data-free-shipping-CZ')) / 100 || 0,
        CA: Number(this.getAttribute('data-free-shipping-CA')) / 100 || 0
      };

      const extraFreeShippingThresholds = {
        DEFAULT: Number(this.getAttribute('data-extra-free-shipping-default')) / 100 || 0,
        FI: Number(this.getAttribute('data-extra-free-shipping-FI')) / 100 || 0,
        LT: Number(this.getAttribute('data-extra-free-shipping-LT')) / 100 || 0,
        DE: Number(this.getAttribute('data-extra-free-shipping-DE')) / 100 || 0,
        FR: Number(this.getAttribute('data-extra-free-shipping-FR')) / 100 || 0,
        HU: Number(this.getAttribute('data-extra-free-shipping-HU')) / 100 || 0,
        LV: Number(this.getAttribute('data-extra-free-shipping-LV')) / 100 || 0,
        US: Number(this.getAttribute('data-extra-free-shipping-US')) / 100 || 0,
        SE: Number(this.getAttribute('data-extra-free-shipping-SE')) / 100 || 0,
        BE: Number(this.getAttribute('data-extra-free-shipping-BE')) / 100 || 0,
        AT: Number(this.getAttribute('data-extra-free-shipping-AT')) / 100 || 0,
        SI: Number(this.getAttribute('data-extra-free-shipping-SI')) / 100 || 0,
        IT: Number(this.getAttribute('data-extra-free-shipping-IT')) / 100 || 0,
        IE: Number(this.getAttribute('data-extra-free-shipping-IE')) / 100 || 0,
        CH: Number(this.getAttribute('data-extra-free-shipping-CH')) / 100 || 0,
        PT: Number(this.getAttribute('data-extra-free-shipping-PT')) / 100 || 0,
        CZ: Number(this.getAttribute('data-extra-free-shipping-CZ')) / 100 || 0,
        CA: Number(this.getAttribute('data-extra-free-shipping-CA')) / 100 || 0
      };

      // Log the input values for debugging
      console.log('Cart Total:', cartTotal);
      console.log('Free Shipping Thresholds:', freeShippingThresholds);
      console.log('Extra Free Shipping Thresholds:', extraFreeShippingThresholds);

      // Get the thresholds for the current country or fallback to default
      const freeShippingThreshold = freeShippingThresholds[countryCode] || freeShippingThresholds.DEFAULT;
      const extraFreeShippingThreshold = extraFreeShippingThresholds[countryCode] || extraFreeShippingThresholds.DEFAULT;

      // Log the thresholds being used
      console.log('Free Shipping Threshold:', freeShippingThreshold);
      console.log('Extra Free Shipping Threshold:', extraFreeShippingThreshold);

      const freeShippingRemaining = freeShippingThreshold - cartTotal;
      const extraFreeShippingRemaining = extraFreeShippingThreshold - cartTotal;

      // Log the remaining amounts
      console.log('Free Shipping Remaining:', freeShippingRemaining);
      console.log('Extra Free Shipping Remaining:', extraFreeShippingRemaining);

      let shippingMessage = '';
      let shippingSuccess = false;
      let progressPercentage = 0;
      let currentThreshold = freeShippingThreshold;

      if (cartTotal < freeShippingThreshold) {
        shippingMessage = window.KROWN.settings.locales.shipping_notice_remaining_to_free.replace('{{ remaining_amount }}', this._formatMoney(freeShippingRemaining * 100, KROWN.settings.shop_money_format));
        progressPercentage = (cartTotal / freeShippingThreshold) * 100;
        currentThreshold = freeShippingThreshold;
      } else if (extraFreeShippingThreshold > 0 && cartTotal < extraFreeShippingThreshold) {
        shippingMessage = window.KROWN.settings.locales.shipping_notice_remaining_to_extra_free.replace('{{ remaining_amount }}', this._formatMoney(extraFreeShippingRemaining * 100, KROWN.settings.shop_money_format));
        progressPercentage = (cartTotal / extraFreeShippingThreshold) * 100;
        currentThreshold = extraFreeShippingThreshold;
      } else if (extraFreeShippingThreshold > 0 && cartTotal >= extraFreeShippingThreshold) {
        shippingMessage = window.KROWN.settings.locales.shipping_notice_eligible_for_extra_free;
        progressPercentage = 100;
        this.showFreebar(); // Show the freebar when extraFreeShippingThreshold is met
        shippingSuccess = true;
      } else if (cartTotal >= freeShippingThreshold) {
        shippingMessage = window.KROWN.settings.locales.shipping_notice_eligible_for_free;
        progressPercentage = 100;
        shippingSuccess = true;
      }

      // Log the final message and success status
      console.log('Shipping Message:', shippingMessage);
      console.log('Shipping Success:', shippingSuccess);
      console.log('Progress Percentage:', progressPercentage);

      // Create the CRAZY animated shipping notice with progress bar and animated truck! 🚚💨
      const progressBarHTML = `
        <style>
          @keyframes truck-bounce {
            0%, 100% { transform: translateY(0px); }
            50% { transform: translateY(-4px); }
          }

          @keyframes truck-drive {
            0% { transform: translateX(0) rotate(0deg); }
            25% { transform: translateX(3px) rotate(-1deg); }
            50% { transform: translateX(0) rotate(0deg); }
            75% { transform: translateX(-3px) rotate(1deg); }
            100% { transform: translateX(0) rotate(0deg); }
          }

          @keyframes wheel-spin {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }

          @keyframes sparkle {
            0%, 100% { opacity: 0; transform: scale(0); }
            50% { opacity: 1; transform: scale(1); }
          }

          @keyframes road-scroll {
            from { background-position: 0 0; }
            to { background-position: 40px 0; }
          }

          @keyframes confetti-fall {
            0% { transform: translateY(-20px) rotate(0deg); opacity: 1; }
            100% { transform: translateY(20px) rotate(360deg); opacity: 0; }
          }

          .shipping-notice-truck {
            animation: ${shippingSuccess ? 'truck-bounce 0.6s ease-in-out infinite' : 'truck-drive 1s ease-in-out infinite'};
            font-size: 32px;
            display: inline-block;
            filter: drop-shadow(0 2px 4px rgba(0,0,0,0.2));
          }

          .shipping-road {
            background: repeating-linear-gradient(
              90deg,
              #ddd 0px,
              #ddd 10px,
              transparent 10px,
              transparent 20px
            );
            animation: road-scroll 1s linear infinite;
            height: 3px;
            border-radius: 2px;
            margin-top: 4px;
          }

          .shipping-sparkle {
            display: inline-block;
            margin-left: 8px;
            animation: sparkle 1.5s ease-in-out infinite;
          }

          .shipping-confetti {
            position: absolute;
            top: -10px;
            font-size: 18px;
            animation: confetti-fall 2s ease-in-out infinite;
          }

          .shipping-progress-container {
            position: relative;
            overflow: visible;
          }

          .shipping-percentage {
            position: absolute;
            right: 8px;
            top: 50%;
            transform: translateY(-50%);
            font-size: 11px;
            font-weight: 700;
            color: ${shippingSuccess ? '#fff' : '#333'};
            z-index: 10;
            text-shadow: ${shippingSuccess ? '0 1px 2px rgba(0,0,0,0.3)' : 'none'};
          }
        </style>

        <div class="shipping-notice-container" style="
          background: linear-gradient(135deg, #4ade80 0%, #22c55e 100%);
          border: none;
          border-radius: 16px;
          padding: 20px;
          margin: 12px 0;
          box-shadow: 0 8px 24px rgba(74, 222, 128, 0.3);
          position: relative;
          overflow: hidden;
        ">
          ${shippingSuccess ? `
            <div class="shipping-confetti" style="left: 20%; animation-delay: 0s;">🎉</div>
            <div class="shipping-confetti" style="left: 40%; animation-delay: 0.3s;">✨</div>
            <div class="shipping-confetti" style="left: 60%; animation-delay: 0.6s;">🎊</div>
            <div class="shipping-confetti" style="left: 80%; animation-delay: 0.9s;">⭐</div>
          ` : ''}

          <div style="display: flex; align-items: center; gap: 12px; margin-bottom: 12px;">
            <div class="shipping-notice-truck">
              🚚
            </div>
            <div style="flex-grow: 1;">
              <div style="font-weight: 700; color: #ffffff; font-size: 15px; margin-bottom: 4px;">
                ${shippingMessage}
                ${shippingSuccess ? '<span class="shipping-sparkle">✨</span>' : ''}
              </div>
              <div style="font-size: 12px; color: rgba(255,255,255,0.9);">
                ${Math.round(progressPercentage)}%
              </div>
            </div>
          </div>

          <div class="shipping-progress-container" style="
            width: 100%;
            height: 24px;
            background: rgba(255, 255, 255, 0.2);
            border-radius: 12px;
            overflow: hidden;
            position: relative;
            backdrop-filter: blur(10px);
            border: 2px solid rgba(255, 255, 255, 0.3);
          ">
            <div class="shipping-progress-fill" style="
              width: ${Math.min(progressPercentage, 100)}%;
              height: 100%;
              background: ${shippingSuccess
                ? 'linear-gradient(90deg, #10b981 0%, #34d399 50%, #6ee7b7 100%)'
                : 'linear-gradient(90deg, #f59e0b 0%, #fbbf24 50%, #fcd34d 100%)'};
              border-radius: 10px;
              transition: width 0.8s cubic-bezier(0.4, 0, 0.2, 1);
              box-shadow: 0 0 20px ${shippingSuccess ? 'rgba(16, 185, 129, 0.6)' : 'rgba(245, 158, 11, 0.6)'};
              position: relative;
            ">
              ${!shippingSuccess && progressPercentage > 10 ? `
                <div style="
                  position: absolute;
                  right: -16px;
                  top: 50%;
                  transform: translateY(-50%);
                  font-size: 24px;
                  animation: truck-drive 1s ease-in-out infinite;
                  filter: drop-shadow(0 2px 8px rgba(0,0,0,0.3));
                ">🚚</div>
              ` : ''}
            </div>
            <div class="shipping-percentage">
              ${Math.round(progressPercentage)}%
            </div>
            ${!shippingSuccess ? '<div class="shipping-road"></div>' : ''}
          </div>

          ${shippingSuccess ? `
            <div style="
              margin-top: 12px;
              text-align: center;
              font-size: 13px;
              color: rgba(255,255,255,0.95);
              font-weight: 600;
              animation: truck-bounce 1s ease-in-out infinite;
            ">
            </div>
          ` : ''}
        </div>
      `;

      if (this.hasAttribute('data-show-alert')) {
        this.innerHTML = progressBarHTML;
      } else {
        this.innerHTML = progressBarHTML;
      }

      if (shippingMessage != '') {
        this.style.display = 'block';
      }

      const checkoutButton = document.querySelector('#CheckOut');
      if (checkoutButton != null) {
        checkoutButton.addEventListener('click', (e) => {
          const t = e.target;
          const parentEl = t.parentElement;
          const ageConfirm = parentEl.querySelector('#ageConfirm');
          const errorMessage = parentEl.querySelector('#error-message');
          
          if (!ageConfirm.checked) {
            e.preventDefault();
            e.stopPropagation();
            
            errorMessage.style.display = 'block';
          } else {
            errorMessage.style.display = 'none';
          }
        });
      }
    }

    async getCountryCodeFromGeolocation() {
      try {
        const response = await fetch('https://ipapi.co/json/?key=sOj1zHcxXJRzvQIbgT9zlRlH7Atr9SldtIMglvbWC1OExlIkO9');
        const data = await response.json();
        console.log('Geolocation API Response:', data); // Log the full response from the API
        return data.country_code || 'default';
      } catch (error) {
        console.error('Geolocation API error:', error);
        return 'default';
      }
    }

    showFreebar() {
      const freebar = document.querySelector('.freebar');
      if (freebar) {
        freebar.style.display = 'block';
      }
    }

    _formatMoney(cents, format) {
      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }

      let value = '';
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      const formatString = format || moneyFormat;

      function formatWithDelimiters(number, precision, thousands, decimal) {
        thousands = thousands || ',';
        decimal = decimal || '.';

        if (isNaN(number) || number === null) {
          return 0;
        }

        number = (number / 100.0).toFixed(precision);

        const parts = number.split('.');
        const dollarsAmount = parts[0].replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          '$1' + thousands
        );
        const centsAmount = parts[1] ? decimal + parts[1] : '';

        return dollarsAmount + centsAmount;
      }

      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ');
          break;
        case 'amount_with_apostrophe_separator':
          value = formatWithDelimiters(cents, 2, "'");
          break;
      }

      return formatString.replace(placeholderRegex, value);
    }
  }

  if (typeof customElements.get('shipping-notice') == 'undefined') {
    customElements.define('shipping-notice', ShippingNotice);
  }

}

document.addEventListener('DOMContentLoaded', function() {
    const shippingNotice = document.querySelector('.cart-notice.hide-if-empty-cart');
    if (shippingNotice) {
        const cartTotalWeight = shippingNotice.getAttribute('data-cart-total-weight');
        console.log('Total Weight in Cart:', cartTotalWeight);
    }
});



